import type { RouteMatch } from './route-match'
import type { AppPageRouteDefinition } from '../route-definitions/app-page-route-definition'

export interface AppPageRouteMatch extends RouteMatch<AppPageRouteDefinition> {}
